import type { PokerGameTileAttribute } from '@ps/web-poker-tile-mappers';
import { AttributeKey } from '@ps/web-poker-tile-mappers';

export default (attributes: PokerGameTileAttribute[]) => {
  const ante = attributes.find(({ key }) => key === AttributeKey.ante);
  let bottomSectionItems = attributes.filter(
    ({ key }) =>
      key === AttributeKey.buyIn ||
      key === AttributeKey.buttonBlind ||
      key === AttributeKey.prizePool ||
      key === AttributeKey.freeRoll ||
      key === AttributeKey.players ||
      key === AttributeKey.seat ||
      key === AttributeKey.stakes ||
      key === AttributeKey.winUpTo
  );

  if (ante) {
    bottomSectionItems = [...bottomSectionItems, ante];
  }

  return bottomSectionItems;
};
